import api from './api';

/**
 * Get left-panel menu tree for the given profile (from OperationMst + RoleOperationMatrix).
 * @param {string} profileCode - Profile/role code (e.g. CRA, PM, SRM, ADMIN). From user.profileCode or user.vUserTypeCode.
 * @returns {Promise<Array>} Array of menu sections (each with operationName, operationPath, children).
 */
const getMenuForProfile = async (profileCode) => {
  if (!profileCode) {
    return [];
  }
  const response = await api.get('/operations/menu', {
    params: { profileCode: profileCode.trim() },
  });
  return response.data || [];
};

const operationService = {
  getMenuForProfile,
};

export default operationService;
